import { useEffect, useRef, MutableRefObject } from 'react';

type Callback = () => void;

export const useTimeout = (callback: Callback, delay: number | null): MutableRefObject<number | null> => {
  const timeoutRef = useRef<number | null>(null);
  const callbackRef = useRef<Callback>(callback);

  // Keep the callback ref up-to-date
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const shouldStartTimeout = typeof delay === 'number';

    const tick = () => callbackRef.current();

    if (shouldStartTimeout) {
      timeoutRef.current = window.setTimeout(tick, delay as number);
      return () => window.clearTimeout(timeoutRef.current!);
    }
  }, [delay]);

  return timeoutRef;
};
